// The formats every page is written in, in the browser: figures and times as
// this reader writes them, in their locale and their own time zone (the
// Worker writes the same pages in UTC). Set once, as app.ts imports this,
// for every module that draws a page.

import { hourLabelLong, timeLabel } from "./chart.ts";
import { setFormats } from "./figures.ts";

// A whole date, in UTC like the daily labels: the all-time peak sits beside
// the range's high/low, which is labelled dayLabel on the daily ranges, and
// the same count under two different days would read as a mistake.
const fullDate = new Intl.DateTimeFormat(undefined, {
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC"
});

setFormats({
  locale: undefined,
  date: (t) => fullDate.format(t * 1000),
  hour: (t) => hourLabelLong.format(t * 1000),
  // That hour today, in the reader's own time.
  clock: (h) => `${timeLabel.format(new Date().setUTCHours(h, 0, 0, 0))} your time`
});
